import { WeddingCakeDecorationStyle } from "./WeddingCakeDecorationStyle.js";
import { WeddingCakeSize } from "./WeddingCakeSize.js";

export const weddingCakePrices = {
	[WeddingCakeSize.Portions12]: {
		[WeddingCakeDecorationStyle.Naked]: 2230,
		[WeddingCakeDecorationStyle.HalfNaked]: 2350,
		[WeddingCakeDecorationStyle.Creamed]: 2650,
		[WeddingCakeDecorationStyle.Birch]: 2770,
		[WeddingCakeDecorationStyle.Individual]: undefined,
	},
	[WeddingCakeSize.Portions18]: {
		[WeddingCakeDecorationStyle.Naked]: 3210,
		[WeddingCakeDecorationStyle.HalfNaked]: 3390,
		[WeddingCakeDecorationStyle.Creamed]: 3840,
		[WeddingCakeDecorationStyle.Birch]: 4020,
		[WeddingCakeDecorationStyle.Individual]: undefined,
	},
	[WeddingCakeSize.Portions25]: {
		[WeddingCakeDecorationStyle.Naked]: 4355,
		[WeddingCakeDecorationStyle.HalfNaked]: 4605,
		[WeddingCakeDecorationStyle.Creamed]: 5230,
		[WeddingCakeDecorationStyle.Birch]: 5480,
		[WeddingCakeDecorationStyle.Individual]: undefined,
	},
	[WeddingCakeSize.Portions30]: {
		[WeddingCakeDecorationStyle.Naked]: 4950,
		[WeddingCakeDecorationStyle.HalfNaked]: 5250,
		[WeddingCakeDecorationStyle.Creamed]: 6000,
		[WeddingCakeDecorationStyle.Birch]: 6300,
		[WeddingCakeDecorationStyle.Individual]: undefined,
	},
	[WeddingCakeSize.Portions40]: {
		[WeddingCakeDecorationStyle.Naked]: 6600,
		[WeddingCakeDecorationStyle.HalfNaked]: 7000,
		[WeddingCakeDecorationStyle.Creamed]: 8000,
		[WeddingCakeDecorationStyle.Birch]: 8400,
		[WeddingCakeDecorationStyle.Individual]: undefined,
	},
	[WeddingCakeSize.Portions50Double]: {
		[WeddingCakeDecorationStyle.Naked]: 7850,
		[WeddingCakeDecorationStyle.HalfNaked]: 8350,
		[WeddingCakeDecorationStyle.Creamed]: 9600,
		[WeddingCakeDecorationStyle.Birch]: 10200,
		[WeddingCakeDecorationStyle.Individual]: undefined,
	},
	[WeddingCakeSize.Portions50Triple]: {
		[WeddingCakeDecorationStyle.Naked]: 8250,
		[WeddingCakeDecorationStyle.HalfNaked]: 8750,
		[WeddingCakeDecorationStyle.Creamed]: 10000,
		[WeddingCakeDecorationStyle.Birch]: 10500,
		[WeddingCakeDecorationStyle.Individual]: undefined,
	},
	[WeddingCakeSize.Portions60]: {
		[WeddingCakeDecorationStyle.Naked]: 9900,
		[WeddingCakeDecorationStyle.HalfNaked]: 10500,
		[WeddingCakeDecorationStyle.Creamed]: 11700,
		[WeddingCakeDecorationStyle.Birch]: 12300,
		[WeddingCakeDecorationStyle.Individual]: undefined,
	},
	[WeddingCakeSize.Portions70]: {
		[WeddingCakeDecorationStyle.Naked]: 11550,
		[WeddingCakeDecorationStyle.HalfNaked]: 12250,
		[WeddingCakeDecorationStyle.Creamed]: 14000,
		[WeddingCakeDecorationStyle.Birch]: 14700,
		[WeddingCakeDecorationStyle.Individual]: undefined,
	},
	[WeddingCakeSize.Portions80]: {
		[WeddingCakeDecorationStyle.Naked]: 13200,
		[WeddingCakeDecorationStyle.HalfNaked]: 14000,
		[WeddingCakeDecorationStyle.Creamed]: 16000,
		[WeddingCakeDecorationStyle.Birch]: 16800,
		[WeddingCakeDecorationStyle.Individual]: undefined,
	},
	[WeddingCakeSize.Portions90]: {
		[WeddingCakeDecorationStyle.Naked]: 14850,
		[WeddingCakeDecorationStyle.HalfNaked]: 15750,
		[WeddingCakeDecorationStyle.Creamed]: 18000,
		[WeddingCakeDecorationStyle.Birch]: 18900,
		[WeddingCakeDecorationStyle.Individual]: undefined,
	},
	[WeddingCakeSize.Portions90Plus]: {
		[WeddingCakeDecorationStyle.Naked]: undefined,
		[WeddingCakeDecorationStyle.HalfNaked]: undefined,
		[WeddingCakeDecorationStyle.Creamed]: undefined,
		[WeddingCakeDecorationStyle.Birch]: undefined,
		[WeddingCakeDecorationStyle.Individual]: undefined,
	},
} satisfies Record<WeddingCakeSize, Record<WeddingCakeDecorationStyle, number | undefined>>;
